/*!
 * devextreme-angular
 * Version: 26.1.6
 * Build date: Fri Oct 16 2026
 *
 * Copyright (c) 2012 - 2026 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/DevExtreme
 */

/* tslint:disable:max-line-length */


import {
    Component,
    OnInit,
    OnDestroy,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';




import type { AnimationConfig } from 'devextreme/common/core/animation';

import {
    DxIntegrationModule,
    NestedOptionHost,
} from 'devextreme-angular/core';
import { NestedOption } from 'devextreme-angular/core';


@Component({
    selector: 'dxo-load-panel-animation',
    template: '',
    styles: [''],
    imports: [ DxIntegrationModule ],
    providers: [NestedOptionHost]
})
export class DxoLoadPanelAnimationComponent extends NestedOption implements OnDestroy, OnInit  {
    @Input()
    get hide(): AnimationConfig {
        return this._getOption('hide');
    }
    set hide(value: AnimationConfig) {
        this._setOption('hide', value);
    }

    @Input()
    get show(): AnimationConfig {
        return this._getOption('show');
    }
    set show(value: AnimationConfig) {
        this._setOption('show', value);
    }


    protected get _optionPath() {
        return 'animation';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }


    ngOnInit() {
        this._addRecreatedComponent();
    }

    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }


}

@NgModule({
  imports: [
    DxoLoadPanelAnimationComponent
  ],
  exports: [
    DxoLoadPanelAnimationComponent
  ],
})
export class DxoLoadPanelAnimationModule { }
